

































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HomeTransitoriaStore from '@/components/Home/Store/HomeTransitoriaStore'
import { maskMoney } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'

@Component

export default class ViewHomeTransitoria extends Vue {
  mAnoReferencia: string = new Date().toISOString().slice(0, 8).concat('01T00:00:00')

  get mesAnoReferencia() { return this.mAnoReferencia }
  set mesAnoReferencia(value: string) { this.mAnoReferencia = value }

  get getHomeTransitoriaStore() {
    return getModule(HomeTransitoriaStore, this.$store)
  }

  get recebimentosHome() {
    return this.getHomeTransitoriaStore.recebimentosHome || []
  }

  get datas() {
    return Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], (n: number) => moment().subtract(n, 'month').format('YYYY-MM-01T00:00:00'))
  }

  get monthSelected() {
    return (moment(this.mesAnoReferencia).format('MMM')).toLocaleUpperCase()
  }

  get yearSelected() {
    return (moment(this.mesAnoReferencia).format('YYYY')).toLocaleUpperCase()
  }

  formatMonthAndYear(value) {
    return (moment(value).format('MMM / YYYY')).toLocaleUpperCase()
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  async ordenacaoChange(value) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    const request = await this.getHomeTransitoriaStore.getAllRecebimentosHome(value)
    if (request.success) this.$vuetify.goTo(0)
    EventBus.$emit('clearLoadingRequest')
  }

  getDescontosTotais(recebimento: any) {
    let descontosTotais: number = 0
    const { gruposRepasse } = recebimento

    if (gruposRepasse !== undefined) {
      descontosTotais = gruposRepasse.reduce((acc: number, curr: any) => {
        const somatorio = (typeof curr === 'object' && !Array.isArray(curr) && curr !== null && 'valorDescontosTotal' in curr) ? acc + curr.valorDescontosTotal : 0
        return somatorio
      }, 0)
    }

    return this.maskMoneyUtil(descontosTotais)
  }

  formatDataSet(recebimento: any) {
    const { valorBrutoTotal, gruposRepasse } = recebimento
    const grupoRepasseDoughnutItems = []
    gruposRepasse.forEach((grupo: any, index: number) => {
      const temp = {
        idGrupoRepasse: grupo.idGrupoRepasse,
        nomeGrupoRepasse: grupo.nomeGrupoRepasse,
        porcentagem: 100 * grupo.valorBrutoTotal / valorBrutoTotal,
        valorBrutoTotal: grupo.valorBrutoTotal,
      }

      // @ts-ignore
      grupoRepasseDoughnutItems.push(temp)
    })

    return grupoRepasseDoughnutItems
  }

  async init() {
    await this.getHomeTransitoriaStore.getAllRecebimentosHome(this.mesAnoReferencia)
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    const mesAnterior = moment().subtract(1, 'month').format('YYYY-MM-01T00:00:00')
    this.mesAnoReferencia = mesAnterior
    await this.init()
    EventBus.$emit('clearLoadingRequest')
  }

  beforeDestroy() {
    this.getHomeTransitoriaStore.clearRecebimentosHome()
    this.getHomeTransitoriaStore.clearRecebimentosTotal()
  }
}
